package com.artvending.warden

class JsSendingQueue: SendingQueue() {
	override suspend fun fix(geolocation: Point, qrCode: String): RequestAnswer? {
		fixingLogger.fix(geolocation, qrCode)
		
		return send(geolocation, qrCode)
	}
}